<!--  -->
<template>
  <div>
    <div class="sizew_text">
      <div
        class="sadrw"
        style="width: 75px;"
      >标题：</div>
      <el-input
        v-model="alltitle"
        placeholder="请输入标题"
        class="text_serw"
      />
    </div>
    <div
      v-if="in_type == 1"
      class="sizew_text"
    >
      <div
        class="sadrw"
        style="width: 75px;"
      >已选企业：</div>
      <div style="max-width: 700px;max-height: 200px; overflow: auto">
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.corp_id,index)"
        >
          {{ itemr.corp_name }}
        </el-tag>
      </div>
      <el-button
        type="success"
        size="mini"
        @click="choose"
      >选择企业</el-button>
    </div>
    <div
      v-if="in_type == 2"
      class="sizew_text"
    >
      <div
        class="sadrw"
        style="width: 75px;"
      >选择企业：</div>
      <el-tag style="margin-right: 10px;">{{ corp_name }}( {{ corp_id }} )</el-tag>
      <!-- <el-button
        type="success"
        size="mini"
        @click="choose2"
      >选择企业</el-button> -->
    </div>
    <div
      v-if="in_type == 3"
      class="sizew_text"
    >
      <div
        class="sadrw"
        style="width: 75px;"
      >选择企业：</div>
      <el-tag style="margin-right: 10px;">{{ corp_name }}( {{ corp_id }} )</el-tag>
      <!-- <el-button
        type="success"
        size="mini"
        @click="choose2"
      >选择企业</el-button> -->
    </div>
    <div
      v-if="in_type == 3"
      class="sizew_text"
    >
      <div
        class="sadrw"
        style="width: 75px;"
      >复制数量：</div>
      <div>
        <el-input-number
          v-model="fu_num"
          :min="1"
          :max="10"
          label="描述文字"
        />
      </div>
    </div>
    <div class="sizew_text">
      <div
        class="sadrw"
        style="width: 75px;"
      >文本：</div>
      <el-input
        v-model="content"
        type="textarea"
        style="width:500px;"
        :rows="4"
        placeholder="请输入内容"
      />
    </div>

    <div class="tab_box">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <!-- 文本 -->
        <el-tab-pane label="仅文本" name="text" />
        <!-- 图片 -->
        <el-tab-pane
          label="图片"
          name="image"
        >
          <img
            v-if="media_id_img"
            class="pic_img"
            :src="pic_url_img"
          >
          <div>
            <el-button
              type="primary"
              size="mini"
              @click="materiallibrary"
            >{{ media_id_img === null ? '素材库选择' : '素材库修改' }}</el-button>
          </div>
        </el-tab-pane>
        <!-- 图文欢迎语 -->
        <el-tab-pane
          label="图文欢迎语"
          name="link"
        >
          <div class="sizew_text">
            <div>标题：</div>
            <el-input
              v-model="title"
              placeholder="请输入标题"
              class="text_serw"
            />
          </div>
          <div class="sizew_text">
            <div>链接：</div>
            <el-input
              v-model="url"
              placeholder="请输入链接"
              class="text_serw"
            />
          </div>
          <div class="sizew_text">
            <div>描述：</div>
            <el-input
              v-model="desc"
              type="textarea"
              :rows="5"
              placeholder="请输入描述"
              class="text_serw"
            />
          </div>
          <div class="sizew_text">
            <div>图片：</div>
            <div>
              <img
                v-if="media_id_link"
                class="pic_img"
                :src="pic_url_link"
              >
              <div style="margin-top: 10px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="materiallibrary"
                >{{ media_id_link === null ? '素材库选择' : '素材库修改' }}</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 小程序欢迎语 -->
        <el-tab-pane
          label="小程序欢迎语"
          name="miniprogram"
        >
          <div class="sizew_text">
            <div class="sadrw">标题：</div>
            <el-input
              v-model="miniprogram_title"
              placeholder="请输入标题"
              class="text_serw"
            />
          </div>
          <div class="sizew_text">
            <div class="sadrw">图片：</div>
            <div>
              <img
                v-if="media_id_miniprogram"
                class="pic_img"
                :src="pic_url_miniprogram"
              >
              <div style="margin-top: 10px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="materiallibrary"
                >{{ media_id_miniprogram === null ? '素材库选择' : '素材库修改' }}</el-button>
              </div>
            </div>
          </div>
          <div class="sizew_text">
            <div class="sadrw">Appid：</div>
            <el-input
              v-model="appid"
              placeholder="请输入Appid"
              class="text_serw"
            />
          </div>
          <div class="sizew_text">
            <div class="sadrw">跳转地址：</div>
            <el-input
              v-model="page"
              placeholder="请输入跳转地址"
              class="text_serw"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div style="text-align:right;padding: 0px 260px">
      <el-button
        type="primary"
        style="margin-top:50px"
        @click="sumbitre"
      >确定</el-button>
    </div>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
    <el-dialog
      title="选择企业"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <div>
        <div class="band_box">
          <div>
            <div class="serch_box">
              <el-input
                v-model="obr.keywords"
                clearable
                style="width:400px;margin-right:10px"
                placeholder="请输入企业id/自有员工编号/员工ID/员工姓名"
              />
              <el-select
                v-model="obr.onlyMe"
                placeholder="请选择"
                style="width:150px"
              >
                <el-option
                  v-for="item in accountarr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-button
                type="primary"
                class="search_icon"
                icon="el-icon-search"
                @click="secahclkick"
              />
            </div>
            <div class="choses_box">
              <div
                class="select_box"
                :class="[fullName?'choose_blockr':'']"
                @click="whole"
              />
              <div
                v-if="fullName"
                @click="whole"
              >
                取消全选
              </div>
              <div
                v-else
                @click="whole"
              >
                全选
              </div>
            </div>
            <div class="choose_allblock">
              <div
                v-for="item,index in arr"
                :key="index"
                :class="[item.tips?'have ':'']"
                class="choose_block"
              >
                <div
                  class="select_box"
                  :class="[item.tips?'choose_blockr':'']"
                  @click="itenclick(item,index)"
                />
                <span>{{ item.corp_name }}<span v-if="item.can_checked == 9">（已设置）</span></span>
              </div>
            </div>

          </div>
          <div class="rigboxr">
            <div class="choiceofficialaccount">选中的企业</div>
            <el-tag
              v-for="itemr,index in arrs"
              :key="index"
              style="margin-right:10px;margin-bottom:5px"
              closable
              :type="itemr.type"
              @close="rightclick(itemr.corp_id,index)"
            >
              {{ itemr.corp_name }}
            </el-tag>
          </div>
        </div>
        <pagination-right
          style="padding:0px;margin-top:20px"
          :total="total"
          :current-page="obr.page"
          :page-size="30"
          :page-sizes="[10,20,30]"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
        <div class="que_box">
          <el-button
            type="primary"
            @click="quebtn"
          >确定</el-button>
        </div>

      </div>
    </el-dialog>
    <el-dialog
      title="选择企业"
      :visible.sync="dialogVisible2"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60"
    >
      <enterprise @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
// import chooseimg from '../../menumanagement/components/chooseimg.vue'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
import enterprise from '../../behavioralsource/components/enterprise.vue'
import { groupWelcomestore, groupWelcomeupdate } from '@/api/weChatMerchants.js'
import { spCorplist } from '@/api/officialaccount'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight, chooseimg, enterprise },
  data() {
    return {
      in_type: null,
      alltitle: '',
      corp_name: null,
      corp_id: '',
      activeName: 'text',
      dialogVisibletwo: false,
      dialogVisible: false,
      dialogVisible2: false,

      content: '',

      media_id_img: null,
      pic_url_img: '',

      title: '',
      url: '',
      desc: '',
      media_id_link: null,
      pic_url_link: '',

      miniprogram_title: '',
      media_id_miniprogram: null,
      pic_url_miniprogram: '',
      appid: '',
      page: '',

      msg_data: {},

      id: null,
      obr: {
        page: 1,
        pageSize: 30,
        keywords: null,
        onlyMe: 2
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内员工'
        },
        {
          value: 2,
          label: '我关联的员工'
        }
      ],
      arrs: [],
      arr: [],
      total: 0,
      fu_num: 1,
      errordata: [],
      errordialog: false
    }
  },
  computed: {
    fullName: function() {
      return this.arr.every(function(item) {
        return item.tips === true
      })
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    materiallibrary() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      console.log(img, key)
      if (this.activeName === 'image') {
        this.pic_url_img = img
        this.media_id_img = key
      }
      if (this.activeName === 'link') {
        this.media_id_link = key
        this.pic_url_link = img
        // this.testsrc = img
      }
      if (this.activeName === 'miniprogram') {
        this.media_id_miniprogram = key
        this.pic_url_miniprogram = img
      }
      this.dialogVisibletwo = false
    },
    send(type, item) {
      this.in_type = type
      console.log(this.in_type, 22, item)
      // eslint-disable-next-line eqeqeq
      if (this.in_type == 1) {
        console.log('新增')
      } else {
        this.id = item.id
        this.alltitle = item.title
        this.corp_name = item.corp_name
        this.corp_id = item.corp_id
        this.activeName = item.msg_type
        // eslint-disable-next-line eqeqeq
        // if (item.msg_type == 'text') {
        //   this.content = item.msg_data.text.content
        // }
        if (item.msg_data.text && item.msg_data.text.content) {
          this.content = item.msg_data.text.content
        }
        // eslint-disable-next-line eqeqeq
        if (item.msg_type == 'image') {
          this.pic_url_img = item.msg_data.image.pic_url
          this.media_id_img = item.msg_data.image.media_id
        }
        // eslint-disable-next-line eqeqeq
        if (item.msg_type == 'link') {
          this.title = item.msg_data.link.title
          this.url = item.msg_data.link.url
          this.desc = item.msg_data.link.desc
          this.media_id_link = item.msg_data.link.media_id
          this.pic_url_link = item.msg_data.link.picurl
        }
        // eslint-disable-next-line eqeqeq
        if (item.msg_type == 'miniprogram') {
          this.miniprogram_title = item.msg_data.miniprogram.title
          this.media_id_miniprogram = item.msg_data.miniprogram.pic_media_id
          this.pic_url_miniprogram = item.msg_data.miniprogram.pic_url
          this.appid = item.msg_data.miniprogram.appid
          this.page = item.msg_data.miniprogram.page
        }
        console.log('item', item)
      }
    },
    async sumbitre() {
      console.log(this.arrs.map(item => item.corp_id))
      // eslint-disable-next-line eqeqeq
      if (this.alltitle == '') {
        this.$message.error('请输入标题')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.arrs == [] && this.corp_id == null) {
        this.$message.error('请选择企业')
        return
      }
      // eslint-disable-next-line eqeqeq
      // if (this.activeName == 'text' && this.content == '') {
      //   this.$message.error('请输入文本内容')
      //   return
      // }
      if (this.activeName === 'text' && this.content === '') {
        this.$message.error('请输入文本内容')
        return
      }
      // eslint-disable-next-line eqeqeq
      // if (this.activeName == 'image' && this.media_id_img == null) {
      //   this.$message.error('请选择图片')
      //   return
      // }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'link' && this.title == '') {
        this.$message.error('请输入标题')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'link' && this.url == '') {
        this.$message.error('请输入链接')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'link' && this.desc == '') {
        this.$message.error('请输入描述')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'link' && this.media_id_link == null) {
        this.$message.error('请选择图片')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'miniprogram' && this.miniprogram_title == '') {
        this.$message.error('请输入标题')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'miniprogram' && this.media_id_miniprogram == null) {
        this.$message.error('请选择图片')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'miniprogram' && this.appid == '') {
        this.$message.error('请输入Appid')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'miniprogram' && this.page == '') {
        this.$message.error('请输入小程序跳转地址')
        return
      }
      this.msg_data = {}
      // eslint-disable-next-line eqeqeq
      // if (this.activeName == 'text') {
      if (this.content && this.content.trim()) {
        this.msg_data.text = {}
        this.msg_data.text.content = this.content
      }
      // }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'image') {
        this.msg_data.image = {}
        this.msg_data.image.media_id = this.media_id_img
        this.msg_data.image.pic_url = this.pic_url_img
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'link') {
        this.msg_data.link = {}
        this.msg_data.link.title = this.title
        this.msg_data.link.picurl = this.pic_url_link
        this.msg_data.link.media_id = this.media_id_link
        this.msg_data.link.desc = this.desc
        this.msg_data.link.url = this.url
      }
      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'miniprogram') {
        this.msg_data.miniprogram = {}
        this.msg_data.miniprogram.title = this.miniprogram_title
        this.msg_data.miniprogram.pic_media_id = this.media_id_miniprogram
        this.msg_data.miniprogram.pic_url = this.pic_url_miniprogram
        this.msg_data.miniprogram.appid = this.appid
        this.msg_data.miniprogram.page = this.page
      }
      // eslint-disable-next-line eqeqeq
      if (this.in_type == 1) {
        console.log('新增')
        groupWelcomestore({
          msg_type: this.activeName,
          msg_data: this.msg_data,
          title: this.alltitle,
          corp_ids: this.arrs.map(item => item.corp_id)
        }).then(res => {
          console.log('res', res.data.fails)
          if (res.data.fails.length !== 0) {
            console.log('res进来', res.data.fails)
            // this.errordialog = true
            // this.errordata = []
            // this.errordata = res.data.fails
            this.$emit('updata', res.data.fails)
          } else {
            this.$emit('updata', [])
          }
        })
      } else if (this.in_type === 2) {
        console.log('编辑')
        await groupWelcomeupdate({
          msg_type: this.activeName,
          msg_data: this.msg_data,
          title: this.alltitle,
          corp_id: this.corp_id,
          id: this.id
        })
        this.$emit('updata', [])
      } else {
        console.log('复用')
        groupWelcomestore({
          msg_type: this.activeName,
          msg_data: this.msg_data,
          title: this.alltitle,
          // corp_ids: this.arrs.map(item => item.corp_id),
          corp_id: this.corp_id,
          num: this.fu_num,
          copy: true
        }).then(res => {
          console.log('res', res)
          // this.$emit('updata')
          // if (res.data.fails.length != 0) {
          //   this.errordialog = true
          //   this.errordata = []
          //   this.errordata = res.data.fails
          // }
          if (res.data.fails.length !== 0) {
            console.log('res进来', res.data.fails)
            // this.errordialog = true
            // this.errordata = []
            // this.errordata = res.data.fails
            this.$emit('updata', res.data.fails)
          } else {
            this.$emit('updata', [])
          }
        })
      }
    },
    choose() {
      this.dialogVisible = true
    },
    choose2() {
      // this.$message.error('编辑不允许修改企业')
      this.dialogVisible2 = true
    },
    async list() {
      const data = await spCorplist(this.obr)
      this.total = data.data.total
      this.tableData = data.data.list
      this.loading = false
      data.data.list.forEach(item => {
        item.tips = false
      })
      this.arr = data.data.list
      this.arr.forEach(item => {
        this.arrs.forEach(items => {
          if (items.corp_id === item.corp_id) {
            console.log('items', item)
            item.tips = true
          }
        })
      })
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.query.suite_id = null
      this.list()
    },
    secahclkick() {
      this.obr.page = 1
      this.list()
    },
    whole() {
      console.log(1111)
      if (this.fullName === true) {
        console.log('666')
        this.arr.forEach(item => {
          item.tips = false
          const index = this.arrs.findIndex(items => {
            return items.corp_id === item.corp_id
          })
          this.arrs.splice(index, 1)
        })
      } else {
        console.log('777')
        this.arr.forEach(item => {
          item.tips = true
          this.arrs.map(re => re.corp_id).includes(item.corp_id) || this.arrs.push({ corp_id: item.corp_id, corp_name: item.corp_name })
        })
      }
    },
    quebtn() {
      this.dialogVisible = false
    },
    rightclick(corp_id, index) {
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.corp_id === corp_id) {
          items.tips = false
        }
      })
    },
    itenclick(item, index) {
      item.tips = !item.tips
      if (item.tips) {
        this.arrs.push({ corp_id: item.corp_id, corp_name: item.corp_name })
      } else {
        const index = this.arrs.findIndex(items => {
          return items.corp_id === item.corp_id
        })
        this.arrs.splice(index, 1)
      }
    },
    callback(val) {
      console.log(val)
      this.dialogVisible2 = false
      this.corp_id = val.corp_id
      this.corp_name = val.corp_name
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tab_box {
  border: 1px solid #dddee1;
  padding: 5px 24px 52px 15px;
  margin-top: 20px;
  margin-left: 75px;
}
.text_serw {
  width: 500px;
}
.pic_img {
  width: 100px;
  height: 100px;
  padding: 10px;
}
.sizew_text {
  color: rgb(169, 162, 151);
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.sadrw {
  width: 70px;
  text-align: right;
}
.band_box {
  display: flex;
}
.serch_box {
  display: flex;
  margin-bottom: 10px;
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.choose_blockr {
  background: #409eff;
}
.rigboxr {
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
.choiceofficialaccount {
  margin-bottom: 10px;
}
.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.have {
  color: #409eff;
}
.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
@media (max-width: 768px){
  .tab_box{
    margin:0px;
    margin-top:5vw;
    padding:3vw;
  }
  .sadrw,.sizew_text{
    font-size:2.8vw;
    color:#0f0f0f;
  }
  .el-tag--medium{
    font-size:2.2vw;
  }
}
</style>
